import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import loader from "../assets/images/loader.gif";
import dayjs from "dayjs";
import axiosClient from "../axios";
import SideBar from "./SideBar";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Pagination_2 from "./Pagination_2";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateConvert } from "../dateConverter";
import "../assets/css/AdminCommon.css"; // V4 Styles

const DailyLoginInfo = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 50,
  });
  const [detailsPagination, setDetailsPagination] = useState({
    page: 0,
    limit: 50,
  });
  const [selectedDate, setSelectedDate] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  const [nextButton, setNextButton] = useState(true);
  const [nextButton1, setNextButton1] = useState(true);
  let [showDate, setShowDate] = useState(true);

  const geUniqueUserLogs = async () => {
    let startDate = date?.start ? dateConvert(date?.start) : null;
    let endDate = date?.end ? dateConvert(date?.end) : null;

    if (startDate && endDate) {
      const diffInDays = dayjs(endDate).diff(dayjs(startDate), "day");
      if (diffInDays < 0) {
        alert("Start date cannot be greater than end date.");
        return;
      }
      if (diffInDays > 30) {
        alert("Date range can't be more than 30 days.");
        return;
      }
    }

    setLoading(true);
    axiosClient
      .get(
        `/dailyloginInfo?s_date=${startDate}&e_date=${endDate}&page=${pagination.page}&limit=${pagination.limit}`
      )
      .then((res) => {
        setData(res?.data?.response);
        setShowDate(true);
        setNextButton1(res?.data?.response?.length >= pagination.limit);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const getUserDetails = (data) => {
    setSelectedDate(data);
    const dateObject = new Date(data?._id);
    let dateData = dateObject.toISOString();

    setLoading(true);

    axiosClient
      .get(
        `/userlogindata?date=${dateData}&page=${detailsPagination.page}&limit=${detailsPagination.limit}`
      )
      .then((res) => {
        setUserDetails(res?.data?.response);
        setShowDate(false);
        setNextButton(res?.data?.response?.length >= detailsPagination.limit);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const clearFilters = () => {
    setDate({ start: null, end: null });
    setPagination({ ...pagination, page: 0 });
    setUserDetails([]);
    setSelectedDate('');
    setShowDate(true);
  };

  useEffect(() => {
    if (selectedDate) {
      getUserDetails(selectedDate);
    }
  }, [detailsPagination]);

  useEffect(() => {
    geUniqueUserLogs();
  }, [pagination]);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"dailyLogingData"} />
      <div className="admin-screen-v4">
        <div className="admin-header-v4">
          <h2>Daily Login Information</h2>
          <div className="dFlex" style={{ gap: "16px" }}>
            {userDetails?.length > 0 && (
              <button
                className="btn-secondary-v4"
                onClick={() => {
                  setUserDetails([]);
                  setSelectedDate('');
                  setShowDate(true);
                  setDetailsPagination({ page: 0, limit: 50 });
                }}
              >
                ← Back to Dates
              </button>
            )}
          </div>
        </div>

        {showDate && (
          <div className="admin-form-container-v4" style={{ marginBottom: "24px" }}>
            <div className="form-section-v4">
              <h3 className="section-header-v4">Date Range Filter</h3>
              <div className="form-row-v4">
                <div className="form-group-v4 date-picker-wrapper-v4">
                  <label className="form-label-v4">Start Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date?.start}
                      onChange={(value) => setDate({ ...date, start: value })}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </div>

                <div className="form-group-v4 date-picker-wrapper-v4">
                  <label className="form-label-v4">End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date?.end}
                      onChange={(value) => setDate({ ...date, end: value })}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>

              <div className="button-group-v4">
                <button
                  className="cancel-button-v4"
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
                <button
                  className="submit-button-v4"
                  onClick={geUniqueUserLogs}
                  disabled={!(date?.start && date?.end)}
                >
                  Get Login Stats
                </button>
              </div>
            </div>
          </div>
        )}

        {!loading ? (
          <div className="admin-form-container-v4">
            {userDetails?.length === 0 ? (
              data?.length > 0 ? (
                <>
                  <div className="table-container-v4">

                    <div className="pagination-buttons-v4">
                      <Pagination_2
                        filterDataInput={pagination}
                        setFilterDataInput={setPagination}
                        showNext={nextButton1}
                      />
                    </div>
                    <table className="data-table-v4">
                      <thead>
                        <tr>
                          <th>S.NO.</th>
                          <th>Date</th>
                          <th>Unique Logins</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((val, key) => (
                          <tr key={key + 1}>
                            <td className="text-muted-v4">
                              {pagination.page * pagination.limit + (key + 1)}
                            </td>
                            <td className="text-link-v4">
                              {val?._id || "—"}
                            </td>
                            <td className="amount-v4">
                              {val?.uniqueUserCount || 0}
                            </td>
                            <td>
                              <button
                                className="btn-action-table-v4 btn-sm-v4"
                                onClick={() => getUserDetails(val)}
                              >
                                View User Details
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </>
              ) : (
                <div className="empty-state-v4">
                  <div className="empty-icon-v4">🔐</div>
                  <h3>No Daily Login Data Found</h3>
                  <p>Select a date range to view daily login information</p>
                </div>
              )
            ) : (
              <>
                <div className="admin-header-v4" style={{ marginBottom: "24px", padding: "16px 24px" }}>
                  <h3 style={{ fontSize: "18px", margin: 0 }}>
                    User Login Details for: <span style={{ color: "var(--primary-color)" }}>{selectedDate?._id}</span>
                  </h3>
                  <div className="pagination-info-v4">
                    <span>Total Users: {userDetails.length}</span>
                  </div>
                </div>

                <div className="table-container-v4">
                  <div className="pagination-buttons-v4">
                    <Pagination_2
                      filterDataInput={detailsPagination}
                      setFilterDataInput={setDetailsPagination}
                      showNext={nextButton}
                    />
                  </div>
                  <table className="data-table-v4">
                    <thead>
                      <tr>
                        <th>S.NO.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Earning</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userDetails?.map((val, key) => (
                        <tr key={key + 1}>
                          <td className="text-muted-v4">
                            {detailsPagination.page * detailsPagination.limit + (key + 1)}
                          </td>
                          <td
                            className="text-link-v4"
                            onClick={() => window.open(`/users/transaction/${val.user_id}`)}
                            style={{ cursor: "pointer" }}
                          >
                            {val?.name || "—"}
                          </td>
                          <td className="text-mono-v4">
                            {val?.emailId || "—"}
                          </td>
                          <td className="text-mono-v4">
                            {val?.phoneNumber || "—"}
                          </td>
                          <td className="amount-v4">
                            {val?.earning || "0"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </>
            )}
          </div>
        ) : (
          <div className="loader-container-v4">
            <img src={loader} alt="Loading..." className="loader-image-v4" />
          </div>
        )}
      </div>
    </>
  );
};

export default DailyLoginInfo;